module.exports = __webpack_public_path__ + "static/filtrated-8caf5ecb073337a38f783af51107e0a2.svg";